import { Injectable } from '@angular/core';
import { IMediaLibraryHandlerStrategy } from '../../../models/util/mediaLibraryHandlerStrategy';
import { Video } from '../../../models/video';
import { FileUtils } from '../../../utils/fileUtils';
import { MediaLibraryFile } from '../../../enums/mediaLibraryFileType.enum';
import { StorageService } from '../../storage/storage.service';
import { environment } from '../../../../environments/environment';
import { isValidHttpUrl } from '@pineapplelab/util';

@Injectable({
	providedIn: 'root'
})
export class MediaLibraryVideoService implements IMediaLibraryHandlerStrategy {

	type: MediaLibraryFile = MediaLibraryFile.VIDEO;

	constructor(
		private storageService: StorageService
	) { }

	async preprocess(file: File): Promise<Video> {
		const video = new Video();
		video.fileName = file?.name;
		video.fileSize = FileUtils.getMB(file).toFixed(2);
		video.__file = file;
		const { duration, thumbnail, thumbnailFile } = await FileUtils.getVideoThumbnail(file, 0);
		video.__fileThumbnail = thumbnailFile;
		video.thumbnail = thumbnail;
		video.duration = duration;
		video.fileType = this.type;
		return video;
	}

	async getThumbnail(media: Video): Promise<string> {
		const thumbnail = await this.storageService.saveOrRemoveImagesIfNecessary(media?.__fileThumbnail, `projects/${environment.projectId}/videos/${media.id}`);
		if (!isValidHttpUrl(thumbnail)) {
			return null;
		}

		return thumbnail;
	}

}
